import { useFormContext } from "react-hook-form";
import Form from 'react-bootstrap/Form';


//https://react-hook-form.com/api/useformcontext

function CredentialComponent(){
    const { register } = useFormContext(); // retrieve all hook methods

    return (
        <section >
            <Form.Group>
                <Form.Label>Username</Form.Label>
                <Form.Control type='text' name="username"  {...register('username')}/>
            </Form.Group>
            <Form.Group>
                <Form.Label>Password</Form.Label>
                <Form.Control type='password' name="password" {...register('password')} />
            </Form.Group>
        </section>
    );
}

export default CredentialComponent;